import { BaseResponse } from 'app/response/internal/baseresponse';
export class TxnSubInfo {
    type: string;
    value: string;
    value_jpn: string;
}

export class TxnSubInfoResult {
    type: string
    list: Array<TxnSubInfo>;
}

export class TxnSubInfoResponse extends BaseResponse {
    data?: TxnSubInfoResult;
}


// WEBPACK FOOTER //
// ./src/app/response/txnsubinforesult.ts